import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const DryerIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "DryerIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M19.8169 2.17749H5.08315C4.74427 2.17749 4.46924 2.45252 4.46924 2.7914V21.2086C4.46924 21.5475 4.74427 21.8225 5.08315 21.8225H19.8169C20.1558 21.8225 20.4308 21.5475 20.4308 21.2086V6.53633C20.4308 6.19745 20.1558 5.92242 19.8169 5.92242C19.478 5.92242 19.203 6.19745 19.203 6.53633V20.5947H5.69706V8.31655H19.8169C20.1558 8.31655 20.4308 8.04152 20.4308 7.70264V2.7914C20.4308 2.45252 20.1558 2.17749 19.8169 2.17749ZM5.69705 3.4053H19.203V7.08874H5.69706L5.69705 3.4053Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.3616 4.63257H12.4503C12.1115 4.63257 11.8364 4.9076 11.8364 5.24648C11.8364 5.58536 12.1115 5.86039 12.4503 5.86039H17.3616C17.7005 5.86039 17.9755 5.58536 17.9755 5.24648C17.9755 4.9076 17.7005 4.63257 17.3616 4.63257Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.99442 5.8636C10.3352 5.8636 10.6114 5.58737 10.6114 5.24662C10.6114 4.90587 10.3352 4.62964 9.99442 4.62964C9.65367 4.62964 9.37744 4.90587 9.37744 5.24662C9.37744 5.58737 9.65367 5.8636 9.99442 5.8636Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M7.53886 5.8636C7.8796 5.8636 8.15584 5.58737 8.15584 5.24662C8.15584 4.90587 7.8796 4.62964 7.53886 4.62964C7.19811 4.62964 6.92188 4.90587 6.92188 5.24662C6.92188 5.58737 7.19811 5.8636 7.53886 5.8636Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.37004 16.3823C8.26578 16.5038 8.22438 16.6533 8.25351 16.8028C8.28418 16.9627 8.39457 17.103 8.55595 17.1877C8.66021 17.2425 8.78096 17.2712 8.90515 17.2712C9.11789 17.2712 9.31798 17.1846 9.43988 17.0401C10.4522 15.8499 9.88798 14.9568 9.47591 14.3044C9.09834 13.7053 8.87027 13.3438 9.44064 12.6726C9.54414 12.5511 9.58515 12.4016 9.5564 12.2525C9.52535 12.0926 9.41496 11.9523 9.25358 11.8673C8.95919 11.7147 8.57166 11.7799 8.36965 12.0152C7.31476 13.2549 7.89127 14.1687 8.31292 14.8376C8.68857 15.434 8.89557 15.7629 8.37004 16.3823Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.0657 16.3826C11.9625 16.5045 11.9219 16.654 11.9507 16.8031C11.9817 16.963 12.0921 17.1029 12.2535 17.1876C12.3577 17.2424 12.4781 17.2711 12.6019 17.2711C12.8135 17.2711 13.0136 17.1849 13.1374 17.04C14.1497 15.8498 13.5855 14.9563 13.1734 14.3043C12.7951 13.7059 12.5666 13.3445 13.1378 12.6725C13.2409 12.5506 13.2819 12.4011 13.2528 12.2516C13.2217 12.0922 13.1113 11.9519 12.95 11.8675C12.656 11.7135 12.268 11.7778 12.066 12.0155C11.0127 13.2551 11.5884 14.1686 12.0093 14.8375C12.3853 15.4343 12.5927 15.7632 12.0657 16.3826Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.7624 16.3827C15.6589 16.5043 15.6179 16.6537 15.6467 16.8029C15.6777 16.9627 15.7881 17.103 15.9495 17.1877C16.0537 17.2425 16.1741 17.2713 16.2979 17.2713C16.511 17.2713 16.7115 17.1846 16.8334 17.0401C17.8461 15.8503 17.2815 14.9568 16.8694 14.3044C16.4911 13.7057 16.263 13.3442 16.8334 12.6726C16.9369 12.5511 16.9779 12.4016 16.9492 12.2525C16.9181 12.0927 16.8077 11.9524 16.6463 11.8673C16.3516 11.7136 15.9637 11.778 15.7624 12.0152C14.7094 13.2545 15.284 14.1679 15.7053 14.8376C16.0813 15.4344 16.2887 15.7633 15.7624 16.3827Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default DryerIcon;
